import React from 'react';
import PInvestDashboard from './pages/PInvestDashboard';
import PInvestFund from './pages/PInvestFund';
import PInvestExpertise from './pages/PInvestExpertise';
import PUserProfile from '../user/pages/PUserProfile';

type InvestorProps = {
	page: string;
};
const Investor = (props: InvestorProps) => {
	const { page } = props;

	switch (page) {
		default:
		case 'dashboard':
			return <PInvestDashboard />;
		case 'fund_type':
			return <PInvestExpertise />;
		case 'fund':
			return <PInvestFund />;
		case 'profile':
			return <PUserProfile />;
	}
};

export default Investor;
